import "./Switch.scss"

import classNames from "classnames"
import React, { useEffect, useRef, useState } from "react"

export const LABEL_TYPES = {
  YES_NO: "YES_NO",
  ON_OFF: "ON_OFF",
  NONE: "",
}

const Switch = ({
  initChecked = false,
  onChange,
  auto = false,
  disabled = false,
  switchKey = "",
  labelClassName = "",
  switchContainerClassName = "",
  labelType = "YES_NO",
  tt,
}) => {
  const [checked, setChecked] = useState(initChecked)
  const inputRef = useRef(null)

  useEffect(() => {
    setChecked(initChecked)
  }, [initChecked])

  const handleChange = e => {
    e.stopPropagation()

    if (auto) {
      setChecked(!checked)
    }

    if (onChange) {
      onChange(!checked)
    }

    if (inputRef.current) {
      inputRef.current.blur()
    }
  }

  const getLabelText = () => {
    switch (labelType) {
      case LABEL_TYPES.YES_NO:
        return checked ? tt("yes") : tt("no")
      case LABEL_TYPES.ON_OFF:
        return checked ? tt("label.on") : tt("label.off")
      default:
        return ""
    }
  }

  const containerClassName = classNames("switch-container-main", {
    [switchContainerClassName]: switchContainerClassName,
    disabled,
  })

  return (
    <div className={containerClassName} key={switchKey}>
      <label className={labelClassName}>
        <input
          ref={inputRef}
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          className="switch"
          type="checkbox"
        />
        <div className="switch-track">
          <div className="switch-handle" />
        </div>
      </label>
      <span className="switch-label">{getLabelText()}</span>
    </div>
  )
}

// Switch.propTypes = {
//   onChange: PropTypes.func,
//   auto: PropTypes.bool,
//   disabled: PropTypes.bool,
//   initChecked: PropTypes.bool,
//   switchKey: PropTypes.string,
//   labelClassName: PropTypes.string,
//   switchContainerClassName: PropTypes.string,
//   labelType: PropTypes.string,
// }

export default React.memo(Switch)
